import axios from "axios";
import { create } from "zustand";

const imageLoadStore = create((set) => ({
  imageLoading: true,

  setImageLoading: async (value) => {
    set({ imageLoading: value });
  },
}));

export default imageLoadStore;
